import { gql } from "apollo-angular";

export const userByUID = gql`
  query userByUID($uid: ID) {
    firebaseUser: userByUID(uid: $uid) {
      id
      Email
      Name
      Given_Name
      Family_Name
      Picture
      Locale
      Verified_Email
      UID
      Phone_Number
      Provider_Id
      TavuelUser {
        id
        NickName_User
        UserState {
          id
          Name_UserState
        }
        NotificationDevices {
          id
          Token_NotificationDevice
          State_NotificationDevice
          FK_Place
        }
        Sudo
        DeliveryRole {
          id
          Name_Role
        }
        FollowedPlaces {
          id
          Name_Place
          Description_Place
        }
        Person {
          id
          Name_Person
          Lastname_Person
          BirthDate_Person
          FK_Country
          ProfileImage
          PersonType {
            id
            Name_PersonType
          }
          DocumentId_Person
          Country {
            id
            Name_Country
            PhoneCode_Country
          }
          Files {
            id
            Route_File
            Created_At
            FileType {
              id
            }
          }
          Addresses {
            id
            Name_Address
            Description_Address
            Lat_Address
            Lng_Address
          }
          Email
          Phone
          Accounts {
            id
            UniqueId_Account
            Total_Account
            FK_GeneralState
          }
          Contacts {
            id
            Data_Contact
            ContactType {
              id
              Name_ContactType
              FontAwesomeIcon_ContactType
            }
          }
        }
        DefaultCoin {
          id
          Name_Coin
          Symbol_Coin
          Sell_Coin
          Buy_Coin
        }
      }
    }
  }
`;

export const getAllCountries = gql`
  query getAllCountries {
    countries: getAllCountries {
      id
      Name_Country
      PhoneCode_Country
      Iso_Country
    }
  }
`;

export const usernameByToken = gql`
  query usernameByToken($meToken: String!) {
    username: usernameByToken(meToken: $meToken)
  }
`;

export const placesByUser = gql`
  query getPlacesByUserAndModule($user: ID!, $module: ID!) {
    places: getPlacesByUserAndModule(FK_User: $user, FK_Module: $module) {
      id
      Name_Place
      Description_Place
      Code
      Lat
      Lng
      Sinpe_Number
      Activity {
        id
        id_MH
        Name
      }
      Company {
        User {
          id
          UserBillingProfile {
            id
            Name
            Email
            ComercialName
            PhoneCodCountry
            PhoneNumber
            ID_Number
            MH_Province {
              id
              Name
            }
            MH_Canton {
              id
              Name
            }
            MH_District {
              id
              Name
            }
            MH_Neighborhood {
              id
              Name
            }
            OtherSigns
            MH_PersonType {
              id
              Name_PersonType
            }
          }
        }
      }
      Delivery {
        id
        Radius
        Available
        Price
        Updated_At
        FreeShipping
        Latitude
        Longitude
        Address
        ProfitPercentage
      }
      Role {
        id
        Name_Role
        Value_Role
      }
      Logo
      PlaceTags {
        id
        Value
        Color
      }
    }
  }
`;

export const getSubmodulesByPlaceAndModuleAndRole = gql`
  query getSubmodulesByPlaceAndModuleAndRole(
    $FK_Place: ID!
    $FK_Module: ID!
    $FK_Role: ID!
  ) {
    submodules: getSubmodulesByPlaceAndModuleAndRole(
      FK_Place: $FK_Place
      FK_Module: $FK_Module
      FK_Role: $FK_Role
    ) {
      id
      Name_Submodule
      Route_Submodule
      Permissions {
        id
        Name_Permission
      }
    }
  }
`;

export const getPermissions = gql`
  query getPermissionsBySubmoduleAndRole($FK_Submodule: ID!, $FK_Role: ID!) {
    permissions: getPermissionsBySubmoduleAndRole(
      FK_Submodule: $FK_Submodule
      FK_Role: $FK_Role
    ) {
      id
      Name_Permission
    }
  }
`;

export const getUserByCriteria = gql`
  query getUserByCriteria($criteria: String) {
    userSelected: getUserByCriteria(criteria: $criteria) {
      id
      FirebaseUser {
        id
        UID
      }
      NickName_User
      Person {
        id
        DocumentId_Person
        Name_Person
        Lastname_Person
        PersonType {
          id
          Name_PersonType
        }
        Country {
          id
          Name_Country
        }
        Contacts {
          id
          Data_Contact
          ContactType {
            id
            Name_ContactType
            FontAwesomeIcon_ContactType
          }
        }
        Files {
          id
          Route_File
          Created_At
          FileType {
            id
          }
        }
        Accounts {
          id
          UniqueId_Account
          FK_GeneralState
        }
      }
      Roles {
        id
        Name_Role
        State
        Place {
          id
          Name_Place
          Description_Place
        }
      }
    }
  }
`;

export const allCoins = gql`
  query coins {
    coins: getAllCoins {
      id
      Name_Coin
      Symbol_Coin
      Buy_Coin
      Sell_Coin
    }
  }
`;

export const billPendingStateAndId = gql`
  query getBillPendings(
    $FK_Place: ID
    $FK_BillStateFilter: ID
    $IdsBills: [ID]
  ) {
    bills: getBillPendings(
      FK_Place: $FK_Place
      FK_BillStateFilter: $FK_BillStateFilter
      IdsBills: $IdsBills
    ) {
      id
      Details_Bill
      Total_Bill
    }
  }
`;

export const activeUserByPlace = gql`
  query getActiveUserByPlace($FK_Place: ID) {
    userActiveByPlace: getActiveUserByPlace(FK_Place: $FK_Place) {
      id
    }
  }
`;

export const productAndCategory = gql`
  query findProductsSoldByCategory($FK_Place: ID!) {
    productsByCategory: findProductsSoldByCategory(FK_Place: $FK_Place) {
      Category
      Name_Product
      Quantity
    }
  }
`;

export const billCurrentCart = gql`
  query getBillCurrentCarts($FK_Place: ID) {
    billCurrentCart: getBillCurrentCarts(FK_Place: $FK_Place) {
      id
    }
  }
`;

export const billsByPlaceAndStateAndIds = gql`
  query getByPlaceAndStateAndIds(
    $FK_Place: ID
    $FK_BillState: [ID]
    $FK_BillDetailState: ID
    $BillDetailIds: [ID]
  ) {
    bills: getByPlaceAndStateAndIds(
      FK_Place: $FK_Place
      FK_BillState: $FK_BillState
      FK_BillDetailState: $FK_BillDetailState
      BillDetailIds: $BillDetailIds
    ) {
      id
      FirebaseId_Bill
      DeliveryMoment
      Payment {
        id
        PayPalID
        PaymentData
        Created_At
        Updated_At
      }
      TypeOfPay {
        id
        Name_TypeOfPay
      }
      Details_Bill
      SubTotal_Bill
      Total_Bill
      Created_At
      Updated_At
      Delivery {
        DeliveryState {
          Name_DeliveryState
        }
        User {
          NickName_User
          Person {
            id
            Name_Person
            Lastname_Person
            Files {
              id
              Route_File
              Created_At
              FileType {
                id
              }
            }
          }
        }
      }
      Address {
        id
        Description_Address
        Lat_Address
        Lng_Address
      }
      User {
        id
        FirebaseUser {
          id
          UID
          Email
        }
        Person {
          id
          Name_Person
          Lastname_Person
          DocumentId_Person
          Phone
          Email
          ProfileImage
        }
      }
      BillType {
        id
        Name_BillType
      }
      BillState {
        id
        Name_BillState
      }
      Refund {
        id
        FK_Bill
        Amount
        State
        ReceiptNumber
        Created_At
      }
    }
  }
`;

export const getRolesByPlace = gql`
  query getRolesByPlace($FK_Place: ID!) {
    roles: getRolesByPlace(FK_Place: $FK_Place) {
      id
      Name_Role
    }
  }
`;

export const getCellars = gql`
  query getCellars($id: ID!) {
    cellars: getCellarsByPlace(id: $id) {
      id
      Description
      Color
      Count
      State_Cellar
      Created_At
      Updated_At
    }
  }
`;

export const getAllBlackBoxDetailType = gql`
  query getAllBlackBoxDetailType {
    blackBoxDetailTypes: getAllBlackBoxDetailType {
      id
      Name_BlackBoxDetailType
    }
  }
`;

export const getUsersByPlace = gql`
  query getUsersByPlace($FK_Place: ID!) {
    users: getUsersByPlace(FK_Place: $FK_Place) {
      id
      NickName_User
      Sudo
      UserState {
        id
        Name_UserState
      }
      Roles {
        id
        Name_Role
      }
      Person {
        id
        Lastname_Person
        Name_Person
        DocumentId_Person
        Files {
          id
          Route_File
          Name_File
          Created_At
          FileType {
            id
          }
        }
        Contacts {
          id
          Data_Contact
          ContactType {
            id
            Name_ContactType
            FontAwesomeIcon_ContactType
          }
        }
      }
      Roles {
        id
        Name_Role
      }
    }
  }
`;

export const findUsersByPlace = gql`
  query findUsersByPlace($Criteria: String!, $FK_Place: ID) {
    users: findUsersByPlace(Criteria: $Criteria, FK_Place: $FK_Place) {
      id
      NickName_User
      Sudo
      UserState {
        id
        Name_UserState
      }
      Person {
        id
        Lastname_Person
        Name_Person
        DocumentId_Person
        Files {
          id
          Route_File
          Name_File
          Created_At
          FileType {
            id
          }
        }
        Contacts {
          id
          Data_Contact
          ContactType {
            id
            Name_ContactType
            FontAwesomeIcon_ContactType
          }
        }
      }
      Roles {
        id
        Name_Role
      }
    }
  }
`;

export const getBlackBoxesByPlace = gql`
  query getBlackBoxesByPlace($placeId: ID!) {
    blackBoxes: getBlackBoxesByPlace(placeId: $placeId) {
      id
      Name_BlackBox
      State_BlackBox
      BlackBoxDetails {
        id
        Value_BlackBoxDetail
        Type {
          id
          Name_BlackBoxDetailType
        }
        Updated_At
      }
      User {
        id
        NickName_User
        Sudo
        UserState {
          id
          Name_UserState
        }
        Person {
          id
          Lastname_Person
          Name_Person
          DocumentId_Person
          Files {
            id
            Route_File
            Name_File
            Created_At
            FileType {
              id
            }
          }
          Contacts {
            id
            Data_Contact
            ContactType {
              id
              Name_ContactType
              FontAwesomeIcon_ContactType
            }
          }
        }
        Roles {
          id
          Name_Role
        }
      }
    }
  }
`;

export const searchBlackBoxes = gql`
  query searchBlackBoxes($criteria: String!, $placeId: ID!) {
    blackBoxes: searchBlackBoxes(criteria: $criteria, placeId: $placeId) {
      id
      Name_BlackBox
      State_BlackBox
      BlackBoxDetails {
        id
        Value_BlackBoxDetail
        Type {
          id
          Name_BlackBoxDetailType
        }
        Updated_At
      }
      User {
        id
        NickName_User
        Sudo
        UserState {
          id
          Name_UserState
        }
        Person {
          id
          Lastname_Person
          Name_Person
          DocumentId_Person
          Files {
            id
            Route_File
            Name_File
            Created_At
            FileType {
              id
            }
          }
          Contacts {
            id
            Data_Contact
            ContactType {
              id
              Name_ContactType
              FontAwesomeIcon_ContactType
            }
          }
        }
        Roles {
          id
          Name_Role
        }
      }
      Created_At
      Updated_At
    }
  }
`;

export const getInventories = gql`
  query inventoryByCellar($id: ID!, $FK_Place: ID) {
    inventories: inventoryByCellar(id: $id, FK_Place: $FK_Place) {
      id
      Description
      State_Inventory
      Count
    }
  }
`;

export const findFeaturesByPlace = gql`
  query findFeaturesByPlace($criteria: String, $id: ID!) {
    featuresFiltered: findFeaturesByPlace(criteria: $criteria, id: $id) {
      id
      ProductPrice {
        id
        Price_ProductPrice
        CalculationMode
        Tax {
          id
          Description_Tax
          MH_Code
        }
        Tariff {
          id
          Name
          Code
          Percent
        }
      }
      Files {
        Route_File
        Name_File
        Created_At
        FileType {
          id
        }
      }
      Quantity_ProductFeature
      Product {
        id
        Name_Product
        Description_Product
        InventoryDetail {
          UnitOfMeasurement {
            id
          }
        }
      }
      Details {
        id
        FK_ProductFeature
        Value_ProductFeatureDetail
        Key_ProductKeyFeature
        FK_ProductKeyFeature
      }
    }
  }
`;

export const getMensuremets = gql`
  query getMensurements {
    measures: getMeasurements {
      id
      Name_UnitOfMeasurement
      Symbol
    }
  }
`;

export const detailByInventory = gql`
  query detailByInventory($id: ID!, $FK_Place: ID) {
    products: detailByInventory(id: $id, FK_Place: $FK_Place) {
      id
      Inventory {
        id
        Description
        Cellar {
          id
          Description
        }
      }
      UnitOfMeasurement {
        id
        Name_UnitOfMeasurement
        Symbol
      }
      Product {
        id
        Name_Product
        Description_Product
        Restricted_Product
        Tags {
          id
          Value
          RelatedTags {
            id
            Value
          }
        }
        ProductState {
          id
          State
        }
        Features {
          id
        }
      }
    }
  }
`;

export const getProductsByInventory = gql`
  query Query($getProductsByInventoryId: ID!) {
    getProductsByInventory(id: $getProductsByInventoryId) {
      id
      Name_Product
      Description_Product
      Features {
        id
      }
      Restricted_Product
      ProductState {
        id
        State
      }
      InventoryDetail {
        id
        UnitOfMeasurement {
          id
        }
      }
      Tags {
        id
        Value
      }
    }
  }
`;

export const getProductByIdWithoutFeatures = gql`
  query getProductByIdWithoutFeatures($getProductByIdWithoutFeatures: ID!) {
    getProductByIdWithoutFeatures(id: $getProductByIdWithoutFeatures) {
      id
      Name_Product
      Description_Product
      Features {
        id
        FK_ProductFeatureState
      }
      Restricted_Product
      ProductState {
        id
        State
      }
      InventoryDetail {
        id
        UnitOfMeasurement {
          id
        }
      }
      Tags {
        id
        Value
        RelatedTags {
          id
          Value
        }
      }
    }
  }
`;

export const detailByInventorySearch = gql`
  query detailByInventory($id: ID!, $FK_Place: ID) {
    products: detailByInventory(id: $id, FK_Place: $FK_Place) {
      id
      UnitOfMeasurement {
        id
        Name_UnitOfMeasurement
        Symbol
      }
      Product {
        id
        Name_Product
        Description_Product
        Restricted_Product
        Tags {
          id
          Value
        }
        ProductState {
          id
          State
        }
        Features {
          LastMonthSells {
            DateSelling
            Quantity
          }
          id
          Location_ProductFeature
          PreparationTime_ProductFeature
          CadesurCode_ProductFeature
          ProductPrice {
            id
            Tax {
              id
              Description_Tax
              MH_Code
            }
            Tariff {
              id
              Name
              Code
              Percent
              Created_At
              Updated_At
            }
            Discount {
              id
              Quantity
              StartDate
              EndDate
            }
            ProductionPrice
            Price_ProductPrice
            CalculationMode
          }
          Files {
            id
            Route_File
            Created_At
            FileType {
              id
            }
          }
          Product {
            id
            Name_Product
            Inventory {
              id
              Description
              Cellar {
                id
                Description
              }
            }
          }
          Codes {
            id
            FeatureCode
            CodeType {
              id
              Name_CodeType
            }
          }
          Details {
            id
            Value_ProductFeatureDetail
            Key_ProductKeyFeature
            FK_ProductKeyFeature
          }
          Quantity_ProductFeature
        }
        Tax {
          id
          Description_Tax
        }
      }
    }
  }
`;

export const getProductStates = gql`
  query getProductStates {
    states: productStates {
      id
      State
    }
  }
`;

export const keysFeatures = gql`
  query allKeysFeatures {
    keysFeatures: allKeysFeatures {
      id
      Name_ProductKeyFeature
      Description_ProductKeyFeature
    }
  }
`;

export const getPriceHistory = gql`
  query getPriceHistory($id: ID!) {
    prices: getPriceHistory(priceId: $id) {
      id
      Price
      Created_At
    }
  }
`;

export const featuresByDetail = gql`
  query featuresByDetail($id: ID!, $FK_Place: ID) {
    features: featuresByDetail(id: $id, FK_Place: $FK_Place) {
      id
      Quantity_ProductFeature
      Location_ProductFeature
      PreparationTime_ProductFeature
      CadesurCode_ProductFeature
      FK_ProductFeatureState
      LastMonthSells {
        DateSelling
        Quantity
      }
      Product {
        id
        Name_Product
        Inventory {
          id
          Description
          Cellar {
            id
            Description
          }
        }
      }
      Codes {
        id
        FeatureCode
        CodeType {
          id
          Name_CodeType
        }
      }
      Files {
        id
        Route_File
        Created_At
        FileType {
          id
        }
      }
      ProductPrice {
        id
        Price_ProductPrice
        CalculationMode
        ProductionPrice
        Discount {
          id
          Quantity
          StartDate
          EndDate
        }
        Tax {
          id
          Description_Tax
          MH_Code
        }
        Tariff {
          id
          Name
          Code
          Percent
        }
        Cabys {
          id
          Code
          Name
          Percent
        }
        Coin {
          id
          Name_Coin
          Symbol_Coin
          Buy_Coin
          Sell_Coin
        }
      }
      Details {
        id
        Value_ProductFeatureDetail
        Key_ProductKeyFeature
        FK_ProductKeyFeature
      }
      Tags {
        id
        Value
      }
    }
  }
`;

export const getBillsByPlaceAndState = gql`
  query getBillsByPlaceAndState(
    $FK_Place: ID
    $FK_BillState: [ID]
    $FK_BillDetailState: ID
  ) {
    bills: getBillsByPlaceAndState(
      FK_Place: $FK_Place
      FK_BillState: $FK_BillState
      FK_BillDetailState: $FK_BillDetailState
    ) {
      id
      FirebaseId_Bill
      TypeOfPay {
        id
        Name_TypeOfPay
      }
      Details_Bill
      SubTotal_Bill
      Total_Bill
      Created_At
      Updated_At
      Address {
        id
        Description_Address
        Lat_Address
        Lng_Address
      }
      User {
        id
        Person {
          id
          Name_Person
          Lastname_Person
          DocumentId_Person
          Contacts {
            id
            Data_Contact
            ContactType {
              id
              Name_ContactType
              FontAwesomeIcon_ContactType
            }
          }
          Files {
            id
            Route_File
            Created_At
            FileType {
              id
            }
          }
        }
      }
      BillType {
        id
        Name_BillType
      }
    }
  }
`;

export const getBillsDateRange = gql`
  query getBillsDateRange(
    $FK_Place: ID
    $StartDate_Bill: String
    $EndDate_Bill: String
  ) {
    getBillsDateRange: getBillsDateRange(
      FK_Place: $FK_Place
      StartDate_Bill: $StartDate_Bill
      EndDate_Bill: $EndDate_Bill
    ) {
      canceled
      delivered
      pending
      toDeliver
    }
  }
`;

export const getTotalBillDateRange = gql`
  query getTotalBillDateRange(
    $FK_Place: ID
    $StartDate_Bill: String
    $EndDate_Bill: String
  ) {
    getTotalBillDateRange: getTotalBillDateRange(
      FK_Place: $FK_Place
      StartDate_Bill: $StartDate_Bill
      EndDate_Bill: $EndDate_Bill
    ) {
      Total_Bill
      Created_At
    }
  }
`;

export const getBillDetailByBillAndPlace = gql`
  query getBillDetailByBillAndPlace($FK_Bill: ID, $FK_Place: ID) {
    details: getBillDetailByBillAndPlace(
      FK_Bill: $FK_Bill
      FK_Place: $FK_Place
    ) {
      id
      Quantity_BillDetail
      FirebaseId_BillDetail
      State {
        id
        Name_BillDetailState
      }
      UnitOfMeasurement {
        id
        Name_UnitOfMeasurement
        Symbol
      }
      ProductFeature {
        id
        Quantity_ProductFeature
        CadesurCode_ProductFeature
        Details {
          id
          Key_ProductKeyFeature
          Value_ProductFeatureDetail
        }
        Files {
          id
          Route_File
          Created_At
          FileType {
            id
          }
        }
        Product {
          id
          Name_Product
          Description_Product
          Inventory {
            id
            Cellar {
              id
              Place {
                id
                Name_Place
                Logo
                Address {
                  id
                  Lat_Address
                  Lng_Address
                }
                Files {
                  id
                  Route_File
                  Created_At
                  FileType {
                    id
                  }
                }
                Address {
                  id
                  Description_Address
                  Lat_Address
                  Lng_Address
                }
              }
            }
          }
        }
        ProductPrice {
          id
          ProductionPrice
          Price_ProductPrice
          CalculationMode
          Tax {
            id
            Description_Tax
            MH_Code
          }
          Tariff {
            id
            Name
            Code
            Percent
          }
        }
      }
    }
  }
`;

export const getDeliveryByUser = gql`
  query getDeliveryByUser($FK_Place: ID) {
    delivery: getDeliveryByUser(FK_Place: $FK_Place) {
      id
      TypeNextPoint_Delivery
      NextPoint {
        id
        Description_Address
        Lat_Address
        Lng_Address
      }
      DeliveryState {
        id
        Name_DeliveryState
      }
      Created_At
      Updated_At
    }
  }
`;

export const getBillDetailsForDeliveryOrder = gql`
  query getBillDetailsForDelivery($FK_Place: ID) {
    details: getBillDetailsForDelivery(FK_Place: $FK_Place) {
      id
      FirebaseId_BillDetail
      Quantity_BillDetail
      CheckedByDelivery_BillDetail

      Bill {
        id
        Details_Bill
        FirebaseId_Bill
        User {
          Person {
            Name_Person
          }
        }
      }
      State {
        id
        Name_BillDetailState
      }
      UnitOfMeasurement {
        id
        Name_UnitOfMeasurement
        Symbol
      }
      ProductFeature {
        id
        Location_ProductFeature
        Quantity_ProductFeature
        Codes {
          id
          FeatureCode
        }
        Details {
          Key_ProductKeyFeature
          Value_ProductFeatureDetail
        }
        Files {
          id
          Route_File
          Created_At
          FileType {
            id
          }
        }
        Product {
          id
          Name_Product
          Description_Product
          Tags {
            id
          }
          MuyTicoTag {
            id
            Value
          }
          Inventory {
            id
            Cellar {
              id
            }
          }
          InventoryDetail {
            id
          }
        }
        ProductPrice {
          id
          Price_ProductPrice
          CalculationMode
          ProductionPrice
          Updated_At
          Tax {
            id
            MH_Code
            Description_Tax
          }
          Tariff {
            id
            Name
            Code
            Percent
          }
          Cabys {
            id
            Code
            Name
            Percent
          }
        }
      }
    }
  }
`;

export const getProductsByPlaceAndCriteria = gql`
  query getProductsByPlaceAndCriteria($criteria: String, $FK_Place: ID) {
    products: getProductsByPlaceAndCriteria(
      criteria: $criteria
      FK_Place: $FK_Place
    ) {
      id
      Quantity_ProductFeature
      Location_ProductFeature
      PreparationTime_ProductFeature
      CadesurCode_ProductFeature
      LastMonthSells {
        DateSelling
        Quantity
      }
      Product {
        id
        Name_Product
        InventoryDetail {
          id
        }
        Inventory {
          id
          Description
          Cellar {
            id
            Description
            Color
          }
        }
      }
      Codes {
        id
        FeatureCode
        CodeType {
          id
          Name_CodeType
        }
      }
      Files {
        id
        Route_File
        Created_At
        FileType {
          id
        }
      }
      ProductPrice {
        id
        Price_ProductPrice
        CalculationMode
        ProductionPrice
        Discount {
          id
          Quantity
          StartDate
          EndDate
        }
        Tax {
          id
          Description_Tax
          MH_Code
        }
        Tariff {
          id
          Name
          Code
          Percent
        }
        Cabys {
          id
          Code
          Name
          Percent
        }
      }
      Details {
        id
        Value_ProductFeatureDetail
        Key_ProductKeyFeature
        FK_ProductKeyFeature
      }
      Tags {
        id
        Value
      }
    }
  }
`;

export const getFilesByPlaceAndType = gql`
  query getFilesByPlaceAndType($FK_Place: ID, $FK_FileType: ID) {
    files: getFilesByPlaceAndType(
      FK_Place: $FK_Place
      FK_FileType: $FK_FileType
    ) {
      id
      Route_File
      Created_At
    }
  }
`;

export const shoppersByPlace = gql`
  query shoppersByPlace($FK_Place: ID) {
    users: shoppersByPlace(FK_Place: $FK_Place) {
      id
      NickName_User
      Person {
        id
        Name_Person
        Lastname_Person
        Files {
          id
          Route_File
          Created_At
          FileType {
            id
          }
        }
      }
    }
  }
`;

export const checkIfAccountIsEnough = gql`
  query checkIfAccountIsEnough($FK_Account: ID, $Total: Float) {
    isEnough: checkIfAccountIsEnough(FK_Account: $FK_Account, Total: $Total)
  }
`;

export const getAllTaxes = gql`
  query getAllTaxes {
    tax: getAllTaxes {
      id
      Description_Tax
      MH_Code
    }
  }
`;

export const getInventoriesByPlace = gql`
  query getInventoriesByPlace($FK_Place: ID) {
    inventories: getInventoriesByPlace(FK_Place: $FK_Place) {
      id
      Description
      Cellar {
        id
        Description
      }
    }
  }
`;

export const getBlackBoxByUserAndPlace = gql`
  query getBlackBoxByUserAndPlace($FK_Place: ID) {
    blackbox: getBlackBoxByUserAndPlace(FK_Place: $FK_Place) {
      id
      Name_BlackBox
      BlackBoxDetails {
        id
        Type {
          id
        }
      }
      Types {
        id
        Name_BlackBoxDetailType
        Coin {
          id
          Name_Coin
          Symbol_Coin
          Sell_Coin
          Buy_Coin
        }
      }
    }
  }
`;

export const checkIfAccountsIsEnough = gql`
  query checkIfAccountsIsEnough($toCheck: [AccountsValidatorInput]) {
    notEnoughAccounts: checkIfAccountsIsEnough(toCheck: $toCheck)
  }
`;

export const getActiveCellarsByPlace = gql`
  query getActiveCellarsByPlace($FK_Place: ID!) {
    cellars: getActiveCellarsByPlace(FK_Place: $FK_Place) {
      id
      Description
      Color
      Inventories {
        id
        Description
        State_Inventory
        Products {
          id
          Name_Product
          Description_Product
          Features {
            id
            Quantity_ProductFeature
            CadesurCode_ProductFeature
            ProductPrice {
              id
              ProductionPrice
              Price_ProductPrice
              CalculationMode
            }
          }
          Features {
            id
            Quantity_ProductFeature
          }
        }
      }
    }
  }
`;

export const getAllTariff = gql`
  query getAllTariff {
    tariff: getAllTariff {
      id
      Name
      Percent
      Code
      Created_At
      Updated_At
    }
  }
`;

export const isPromotionalCodeValidForCashier = gql`
  query isPromotionalCodeValidForCashier(
    $FK_User: ID
    $UniqueCode_PromotionalCode: String
  ) {
    code: isPromotionalCodeValidForCashier(
      FK_User: $FK_User
      UniqueCode_PromotionalCode: $UniqueCode_PromotionalCode
    ) {
      id
      Discount_PromotionalCode
      EndDate_PromotionalCode
    }
  }
`;

export const getBlackBoxByUser = gql`
  query getBlackBoxByUser {
    blackbox: getBlackBoxByUser {
      id
      Name_BlackBox
      BlackBoxDetails {
        id
        Type {
          id
        }
      }
      Types {
        id
        Name_BlackBoxDetailType
        Coin {
          id
          Name_Coin
          Symbol_Coin
          Sell_Coin
          Buy_Coin
        }
      }
    }
  }
`;

export const checkIfPasswordAndAccountIsEnough = gql`
  query checkIfPasswordAndAccountIsEnough(
    $FK_User: ID
    $FK_Account: ID
    $Total: Float
    $Password_User: String
  ) {
    valid: checkIfPasswordAndAccountIsEnough(
      FK_User: $FK_User
      FK_Account: $FK_Account
      Total: $Total
      Password_User: $Password_User
    )
  }
`;

export const getBillsForDelivery = gql`
  query getBillsForDelivery {
    bills: getBillsForDelivery {
      id
      FirebaseId_Bill
      OrderDate_Bill
      Details_Bill
      Total_Bill
      Address {
        id
        Description_Address
        Lat_Address
        Lng_Address
      }
      User {
        id
        Person {
          id
          Name_Person
          Lastname_Person
          DocumentId_Person
          Email
          Phone
          Files {
            id
            Route_File
            Created_At
            FileType {
              id
            }
          }
        }
      }
      BillState {
        id
        Name_BillState
      }
      Detail {
        id
        FirebaseId_BillDetail
        Quantity_BillDetail
        CheckedByDelivery_BillDetail
        State {
          id
          Name_BillDetailState
        }
        UnitOfMeasurement {
          id
          Name_UnitOfMeasurement
          Symbol
        }
        ProductFeature {
          id
          Quantity_ProductFeature
          Details {
            id
            Key_ProductKeyFeature
            Value_ProductFeatureDetail
          }
          Files {
            id
            Route_File
            Created_At
            FileType {
              id
            }
          }
          Product {
            id
            Name_Product
            Description_Product
            Inventory {
              id
              Cellar {
                id
                Place {
                  id
                  Name_Place
                  Logo
                  Address {
                    id
                    Lat_Address
                    Lng_Address
                  }
                  Files {
                    id
                    Route_File
                    Created_At
                    FileType {
                      id
                    }
                  }
                  Address {
                    id
                    Description_Address
                    Lat_Address
                    Lng_Address
                  }
                }
              }
            }
          }
          ProductPrice {
            id
            Price_ProductPrice
            CalculationMode
          }
        }
      }
      BillType {
        id
        Name_BillType
      }
      TypeOfPay {
        id
        Name_TypeOfPay
      }
    }
  }
`;

export const getBillDetailsForDelivery = gql`
  query getBillDetailsForDelivery($FK_Place: ID) {
    details: getBillDetailsForDelivery(FK_Place: $FK_Place) {
      id
      FirebaseId_BillDetail
      Quantity_BillDetail
      CheckedByDelivery_BillDetail

      Bill {
        id
        Details_Bill
        OrderDate_Bill
        FirebaseId_Bill
        DeliveryMoment
        DeliverDate_Bill
        BillState {
          id
          Name_BillState
        }
        TypeOfPay {
          Name_TypeOfPay
        }
        User {
          id
          Person {
            id
            Name_Person
            Lastname_Person
            DocumentId_Person
            ProfileImage
            Contacts {
              id
              Data_Contact
              ContactType {
                id
                Name_ContactType
                FontAwesomeIcon_ContactType
              }
            }
            Files {
              id
              Route_File
              Created_At
              FileType {
                id
              }
            }
          }
        }
      }
      State {
        id
        Name_BillDetailState
      }
      UnitOfMeasurement {
        id
        Name_UnitOfMeasurement
        Symbol
      }
      ProductFeature {
        id
        Quantity_ProductFeature
        Codes {
          id
          FeatureCode
        }
        Details {
          Key_ProductKeyFeature
          Value_ProductFeatureDetail
        }
        Files {
          id
          Route_File
          Created_At
          FileType {
            id
          }
        }
        Product {
          id
          Name_Product
          Description_Product
          Inventory {
            id
            Cellar {
              id
              Place {
                id
                Name_Place
                Logo
                Address {
                  id
                  Lat_Address
                  Lng_Address
                }
                Files {
                  id
                  Route_File
                  Created_At
                  FileType {
                    id
                  }
                }
                Address {
                  id
                  Description_Address
                  Lat_Address
                  Lng_Address
                }
              }
            }
          }
        }
        ProductPrice {
          id
          Price_ProductPrice
          CalculationMode
        }
      }
    }
  }
`;

export const sonTags = gql`
  query sonTags($id: ID!) {
    tags: sonTags(id: $id) {
      id
      Value
      Clicks
      Color
      TagCategory {
        id
        Category
      }
      FeatureTags {
        id
        Value
      }
      RelatedTags {
        id
        Value
      }
      File {
        id
        Route_File
        FirebaseId
      }
    }
  }
`;
export const getStatsById = gql`
  query getStatsById($placeId: Int!) {
    getStatsById(placeId: $placeId) {
      carts
      users
      orders
    }
  }
`;

export const searchTagByCategory = gql`
  query searchTagByCategory($value: String, $categoryId: String) {
    tags: searchTagByCategory(value: $value, categoryId: $categoryId) {
      id
      Value
      Color
    }
  }
`;

export const searchTags = gql`
  query searchTag($criteria: String) {
    tags: searchTag(value: $criteria) {
      id
      Value
      Clicks
      Color
      TagCategory {
        id
        Category
      }
    }
  }
`;

export const getAllBillStates = gql`
  query getAllBillStates {
    states: getAllBillStates {
      id
      Name_BillState
    }
  }
`;

export const getBillStateMarket = gql`
  query getBillStateMarket {
    states: getBillStateMarket {
      id
      Name_BillState
    }
  }
`;

export const getBillsByStateAndPlaceAndDateRange = gql`
  query getBillsByStateAndPlaceAndDateRange(
    $FK_Place: ID
    $FK_BillState: ID
    $StartDate_Bill: String
    $EndDate_Bill: String
  ) {
    report: getBillsByStateAndPlaceAndDateRange(
      FK_Place: $FK_Place
      FK_BillState: $FK_BillState
      StartDate_Bill: $StartDate_Bill
      EndDate_Bill: $EndDate_Bill
    ) {
      id
      AdminCreator
      Details_Bill
      OrderDate_Bill
      CashAmount
      FirebaseId_Bill
      DeliveryMoment
      DeliverDate_Bill
      Total_Bill
      SubTotal_Bill
      phoneNumber
      HasCreditNote
      EB {
        id
        FK_Bill
        Key
        Xml
        XmlResp
        Response
        Request
        Callback
        Created_At
        Updated_At
      }
      CreditNoteInfo {
        id
        Key
        EmitedDay
        ReferenceCode
        ReferenceReason
        ConsecutiveNumber
        ActivityCode
        Receiver {
          id
          ValidBillingProfile
          UserBillingProfile {
            id
            Name
            Email
            ComercialName
            PhoneCodCountry
            PhoneNumber
            ID_Number
            MH_Province {
              id
              Name
            }
            MH_Canton {
              id
              Name
            }
            MH_District {
              id
              Name
            }
            MH_Neighborhood {
              id
              Name
            }
            OtherSigns
            MH_PersonType {
              id
              Name_PersonType
            }
          }
          Person {
            Name_Person
            Lastname_Person
            DocumentId_Person
            Email
            Phone
            Contacts {
              id
              Data_Contact
              ContactType {
                id
                Name_ContactType
              }
            }
          }
        }
        Coin {
          id
          Name_Coin
          Buy_Coin
        }
        Bill {
          id
          TypeOfPay {
            id
            Name_TypeOfPay
          }
        }
        ElectronicBillDocumentType {
          id
          Description
          Value
        }
        ElectronicBillDetail {
          id
          Quantity
          Created_At
          Updated_At
          ProductFeature {
            id
            Product {
              id
              Name_Product
              Description_Product
              Tags {
                id
                Value
              }
              InventoryDetail {
                id
              }
              Inventory {
                id
                Cellar {
                  id
                  Place {
                    id
                    Name_Place
                    Logo
                    Address {
                      id
                      Description_Address
                      Lat_Address
                      Lng_Address
                    }
                    Schedules {
                      id
                      OpenHour_Schedule
                      CloseHour_Schedule
                      Detail {
                        id
                        Day {
                          id
                          Name_Day
                          Value_Day
                        }
                      }
                    }
                  }
                }
              }
            }
            ProductPrice {
              Price_ProductPrice
              CalculationMode
              ProductionPrice
              Tax {
                id
                Description_Tax
              }
              Cabys {
                id
                Percent
                Name
                Code
              }
            }
          }
        }
        Created_At
        Updated_At
      }
      RequiresElectronicInvoice
      Refund {
        id
        Amount
        State
        Created_At
        Updated_At
        TypeOfPay {
          id
          Name_TypeOfPay
        }
        File {
          id
          Route_File
          Created_At
          FileType {
            id
          }
        }
      }
      Detail {
        id
        State {
          id
          Name_BillDetailState
        }
        ProductFeature {
          id
          Product {
            id
            Name_Product
            Description_Product
          }
          ProductPrice {
            Price_ProductPrice
            CalculationMode
            ProductionPrice
            Tax {
              id
              Description_Tax
            }
            Cabys {
              id
              Percent
              Name
              Code
            }
          }
        }
        Quantity_BillDetail
      }
      Coin {
        id
        Name_Coin
        Symbol_Coin
        Buy_Coin
        Sell_Coin
      }
      File {
        id
        Route_File
        FileType {
          id
          Name_FileType
        }
      }
      Address {
        id
        Description_Address
        Name_Address
        Lat_Address
        Lng_Address
      }
      BillState {
        id
        Name_BillState
      }
      TypeOfPay {
        id
        Name_TypeOfPay
      }
      User {
        id
        BillingProfile
        ValidBillingProfile
        UserBillingProfile {
          id
          Name
          MH_PersonType {
            id
            Name_PersonType
            Code
          }
          ID_Number
          IDForeign
          ComercialName
          Email
          PhoneCodCountry
          PhoneNumber
          Tax_Registration
          MH_Province {
            id
            Name
            id_MH
          }
          MH_Canton {
            id
            Name
            id_MH
          }
          MH_District {
            id
            Name
            id_MH
          }
          MH_Neighborhood {
            id
            Name
            id_MH
          }
          MH_User {
            idUser
            fullName
            userName
            email
            pwd
            about
            country
            FileEB {
              idFile
              md5
              name
              timestamp
              size
              idUser
              fileType
              type
            }
            Session {
              idSession
              idUser
              sessionKey
              ip
              lastAccess
            }
            MH_User
            MH_Password
          }
          OtherSigns
          OtherSignsForeign
        }
        Person {
          id
          Name_Person
          Lastname_Person
          DocumentId_Person
          ProfileImage
          Email
          Phone
          Contacts {
            id
            Data_Contact
            ContactType {
              id
              Name_ContactType
              FontAwesomeIcon_ContactType
            }
          }
          Files {
            id
            Route_File
            Created_At
            FileType {
              id
            }
          }
        }
      }
    }
  }
`;

export const reportForProviders = gql`
  query reportForProviders($FK_Place: ID) {
    features: reportForProviders(FK_Place: $FK_Place) {
      id
      Quantity_ProductFeature
      Product {
        id
        Name_Product
        Inventory {
          id
          Description
          Cellar {
            id
            Description
          }
        }
      }
      Files {
        id
        Route_File
        Created_At
        FileType {
          id
        }
      }
      ProductPrice {
        id
        Price_ProductPrice
        CalculationMode
      }
      Details {
        id
        Value_ProductFeatureDetail
        Key_ProductKeyFeature
        FK_ProductKeyFeature
      }
    }
  }
`;

export const getDeliveryStates = gql`
  query getDeliveryStates {
    states: getDeliveryStates {
      id
      Name_DeliveryState
    }
  }
`;

export const getAllBillDetailStates = gql`
  query getAllBillDetailStates {
    states: getAllBillDetailStates {
      id
      Name_BillDetailState
    }
  }
`;

export const getCompaniesByModule = gql`
  query getCompaniesByModule($FK_Module: ID) {
    companies: getCompaniesByModule(FK_Module: $FK_Module) {
      id
      Name_Company
      Description_Company
      UniqueName_Company
      PrimaryColor_Company
      SecondaryColor_Company
      BackgroundColor_Company
      Vision_Company
      Mission_Company
      Country {
        id
        Name_Country
      }
      User {
        id
        FirebaseUser {
          id
          Email
          Name
          Given_Name
          Phone_Number
        }
        Person {
          id
          DocumentId_Person
          PersonType {
            id
            Name_PersonType
          }
        }
      }
      Contacts {
        id
        Data_Contact
        ContactType {
          id
          Name_ContactType
          FontAwesomeIcon_ContactType
        }
      }
      Files {
        id
        Route_File
        Created_At
        FileType {
          id
        }
      }
      Places {
        id
        Name_Place
        Description_Place
        UniqueName_Place
        PrimaryColor_Place
        SecondaryColor_Place
        ThirdColor_Place
        Followers
        Logo
        Address {
          id
          Lat_Address
          Lng_Address
          GoogleCode_Address
        }
        Contacts {
          id
          Data_Contact
          ContactType {
            id
            Name_ContactType
            FontAwesomeIcon_ContactType
          }
        }
        Files {
          id
          Route_File
          Created_At
          FileType {
            id
          }
        }
        ProfileTags {
          id
          Color_PlaceProfileTag
          Background_PlaceProfileTag
          File {
            id
            Route_File
            Created_At
            FileType {
              id
            }
          }
          Tag {
            id
            Value
          }
        }
        Schedules {
          id
          OpenHour_Schedule
          CloseHour_Schedule
          Detail {
            id
            Day {
              id
              Name_Day
              Value_Day
            }
          }
        }
        PlaceInfo {
          id
          Title_PlaceInfo
          LittleTitle_PlaceInfo
          BigText_PlaceInfo
        }
      }
    }
  }
`;

export const getCompanyByUniqueName = gql`
  query getCompanyByUniqueName($UniqueName_Company: String) {
    company: getCompanyByUniqueName(UniqueName_Company: $UniqueName_Company) {
      id
      Name_Company
      Description_Company
      UniqueName_Company
      PrimaryColor_Company
      SecondaryColor_Company
      BackgroundColor_Company
      Vision_Company
      Mission_Company
      Country {
        id
        Name_Country
      }
      User {
        id
        FirebaseUser {
          id
          Email
          Name
          Given_Name
          Phone_Number
        }
        Person {
          id
          DocumentId_Person
          PersonType {
            id
            Name_PersonType
          }
        }
      }
      Contacts {
        id
        Data_Contact
        ContactType {
          id
          Name_ContactType
          FontAwesomeIcon_ContactType
        }
      }
      Files {
        id
        Route_File
        Created_At
        FileType {
          id
        }
      }
      Places {
        id
        Name_Place
        Description_Place
        Followers
        Address {
          id
          Lat_Address
          Lng_Address
          GoogleCode_Address
        }
        Contacts {
          id
          Data_Contact
          ContactType {
            id
            Name_ContactType
            FontAwesomeIcon_ContactType
          }
        }
        Files {
          id
          Route_File
          Created_At
          FileType {
            id
          }
        }
      }
    }
  }
`;

export const getCategoriesOfProducts = gql`
  query getCategoriesOfProducts($criteria: String) {
    tags: getCategoriesOfProducts(criteria: $criteria) {
      id
      Value
      Color
    }
  }
`;

export const allTagsCategory = gql`
  query allTagsCategory {
    tagsCategory: allTagsCategory {
      id
      Category
    }
  }
`;

export const tagsByCategory = gql`
  query tagsByCategory($id: ID!) {
    tags: tagsByCategory(id: $id) {
      id
      Value
      Clicks
      Color
      TagCategory {
        id
        Category
      }
    }
  }
`;

export const getAllPromotionalCodes = gql`
  query getAllPromotionalCodes {
    codes: getAllPromotionalCodes {
      id
      UniqueCode_PromotionalCode
      Discount_PromotionalCode
      SpentQuantity_PromotionalCode
      TotalQuantity_PromotionalCode
      StartDate_PromotionalCode
      EndDate_PromotionalCode
      Created_At
      Updated_At
      User {
        id
        NickName_User
      }
      State {
        id
        Name_PromotionalCodeState
      }
    }
  }
`;

export const generateRandomPromotionalCodeName = gql`
  query generateRandomPromotionalCodeName {
    code: generateRandomPromotionalCodeName
  }
`;

export const billsByIds = gql`
  query billsByIds($ids: [ID]) {
    bills: billsByIds(ids: $ids) {
      id
      FirebaseId_Bill
      SubTotal_Bill
      Total_Bill
      Distance_Bill
      Details_Bill
      Created_At
      Updated_At
      OrderDate_Bill
      TotalDelivery
      DeliveryTax
      Services
      Address {
        id
        Description_Address
        Name_Address
        Lat_Address
        Lng_Address
      }
      User {
        id
        FirebaseUser {
          id
          UID
          Email
        }
        Person {
          id
          Name_Person
          Lastname_Person
          DocumentId_Person
          Email
          Phone
          Files {
            id
            Route_File
            Created_At
            FileType {
              id
            }
          }
        }
      }
      BillState {
        id
        Name_BillState
      }
    }
  }
`;

export const billsDeliveredReport = gql`
  query billsDeliveredReport($dateA: DateTime!, $dateB: DateTime!) {
    billsDeliveredReport(dateA: $dateA, dateB: $dateB) {
      DateDelivery
      Distance
      Services
      TotalDelivery
      DeliveryTax
      Bills {
        id
        OrderDate_Bill
        DeliverDate_Bill
        SubTotal_Bill
        Total_Bill
        Distance_Bill
        TotalDelivery
        DeliveryTax
        Services
        BillState {
          id
          Name_BillState
        }
        Address {
          id
          Name_Address
          Description_Address
          Lat_Address
          Lng_Address
        }
        Created_At
        Updated_At
      }
    }
  }
`;
export const notAvailableAddressToSend = gql`
  query notAvailableAddressToSend {
    notAvailableAddressToSend {
      id
      Distance
      Bill {
        Details_Bill
        id
      }
      Amount
      Approved
      Tax
      Services
      Delivery
      DeliveryTax
      Time
      Lat
      Lng
      Created_At
      Address {
        id
        Name_Address
        Description_Address
      }
      User {
        id
        Person {
          id
          Name_Person
          Lastname_Person
          Email
          Phone
          ProfileImage
        }
      }
    }
  }
`;

export const recentUsers = gql`
  query recentUsers($offset: Int) {
    users: recentUsers(offset: $offset) {
      id
      Email
      Given_Name
      Family_Name
      Picture
      Locale
      Phone_Number
      UID
      Provider_Id
      Created_At
      Updated_At
      User {
        id
        Person {
          id
          Name_Person
          Lastname_Person
          Phone
          Email
          BirthDate_Person
          ProfileImage
        }
        UserRoles {
          id
        }
        Roles {
          Name_Role
        }
        Cart {
          id
          Total_Bill
          Detail {
            id
          }
        }
      }
    }
  }
`;

export const placeClients = gql`
  query GetPlaceClients($placeByClientParams: PlaceByClientParams!) {
    users: GetPlaceClients(placeByClientParams: $placeByClientParams) {
      id
      Updated_At
      Created_At
      Cart {
        id
        Total_Bill
        Detail {
          id
        }
      }
      Person {
        id
        Name_Person
        Lastname_Person
        Phone
        Email
        BirthDate_Person
        ProfileImage
        Phone
      }
    }
  }
`;

export const addressByPerson = gql`
  query addressByPerson($id: ID) {
    address: addressByPerson(id: $id) {
      id
      Name_Address
      Description_Address
      Lat_Address
      Lng_Address
    }
  }
`;

export const discounts = gql`
  query discounts($FK_Place: String, $State: Boolean) {
    discounts(FK_Place: $FK_Place, State: $State) {
      id
      Quantity
      StartDate
      EndDate
      State
      Created_At
      Updated_At
      Prices
    }
  }
`;

export const downloadXML = gql`
  query downloadXML($id: String!) {
    downloadXML(id: $id)
  }
`;

export const downloadRespXML = gql`
  query downloadRespXML($id: String!) {
    downloadRespXML(id: $id)
  }
`;

export const electronicBillByBill = gql`
  query electronicBillByBill($id: ID!, $FK_Place: ID!) {
    electronicBillByBill(id: $id, FK_Place: $FK_Place) {
      id
      Key
      Response
      Request
      Callback
      Created_At
      Updated_At
    }
  }
`;

export const serverDate = gql`
  query serverDate {
    serverDate
  }
`;

export const productFeatureByCadesurCode = gql`
  query productFeatureByCadesurCode($id: ID!) {
    productFeatureByCadesurCode(id: $id) {
      id
      CadesurCode_ProductFeature
      Quantity_ProductFeature
      Updated_At
      Details {
        id
        Value_ProductFeatureDetail
        Key_ProductKeyFeature
        FK_ProductKeyFeature
      }
      Files {
        id
        Route_File
        Created_At
        FileType {
          id
        }
      }
      Product {
        id
        Name_Product
        Description_Product
        InventoryDetail {
          id
        }
        Inventory {
          id
          Description
          Cellar {
            id
            Description
          }
        }
      }
      ProductPrice {
        id
        Price_ProductPrice
        CalculationMode
        ProductionPrice
        Updated_At
        Tax {
          id
          MH_Code
          Description_Tax
        }
        Tariff {
          id
          Name
          Code
          Percent
        }
        Cabys {
          id
          Code
          Name
          Percent
        }
      }
    }
  }
`;

export const tagsByInventoryDetailPlace = gql`
  query tagsByInventoryDetailPlace($id: ID!, $FK_Place: ID!) {
    tagsByInventoryDetailPlace(id: $id, FK_Place: $FK_Place) {
      id
      Value
    }
  }
`;

export const validatePhone = gql`
  query validatePhone($phone: String, $codeRegion: String) {
    validatePhone: validatePhone(phone: $phone, codeRegion: $codeRegion) {
      invalidCountryPhone
    }
  }
`;

export const activities = gql`
  query {
    activities: allActivities {
      id
      id_MH
      Name
    }
  }
`;

export const userByCriteria = gql`
  query userByCriteria($criteria: String) {
    queryUsers: userByCriteria(criteria: $criteria) {
      id
      BillingProfile
      ValidBillingProfile
      FirebaseUser {
        id
        UID
      }
      NickName_User
      Person {
        id
        DocumentId_Person
        Name_Person
        Lastname_Person
        Email
        Phone
        Email
        ProfileImage
        Accounts {
          id
          UniqueId_Account
          FK_GeneralState
        }
      }
    }
  }
`;

export const billsByPlace = gql`
  query billsByPlace($FK_Place: ID!) {
    billsByPlace(FK_Place: $FK_Place) {
      id
      DeliveryMoment
      User {
        id
        BillingProfile
        ValidBillingProfile
        FirebaseUser {
          id
          UID
        }
        NickName_User
        Person {
          id
          DocumentId_Person
          Name_Person
          Lastname_Person
          Email
          Phone
          Email
          ProfileImage
          Accounts {
            id
            UniqueId_Account
            FK_GeneralState
          }
        }
      }
      NotAvailableAddressToSend {
        id
        Lat
        Lng
        Distance
        Amount
        Tax
        Services
        Delivery
        DeliveryTax
        Time
        User {
          id
        }
        Address {
          id
        }
        Approved
      }
      Address {
        id
        Name_Address
        Description_Address
        Lat_Address
        Lng_Address
      }
      Detail {
        id
        Quantity_BillDetail
        SubTotal_BillDetail
        Total_BillDetail
        State {
          id
          Name_BillDetailState
        }
        UnitOfMeasurement {
          id
          Name_UnitOfMeasurement
          Symbol
        }
        ProductFeature {
          id
          Quantity_ProductFeature
          PreparationTime_ProductFeature
          Details {
            id
            Key_ProductKeyFeature
            Value_ProductFeatureDetail
          }
          Files {
            id
            Route_File
            Created_At
            FileType {
              id
              Name_FileType
            }
          }
          Product {
            id
            Name_Product
            Description_Product
            Tags {
              id
              Value
            }
            InventoryDetail {
              id
            }
            Inventory {
              id
              Cellar {
                id
                Place {
                  id
                  Name_Place
                  Logo
                  Address {
                    id
                    Lat_Address
                    Lng_Address
                  }
                  Schedules {
                    id
                    OpenHour_Schedule
                    CloseHour_Schedule
                    Detail {
                      id
                      Day {
                        id
                        Name_Day
                        Value_Day
                      }
                    }
                  }
                }
              }
            }
          }
          ProductPrice {
            id
            Discount {
              id
              Quantity
              StartDate
              EndDate
            }
            Price_ProductPrice
            CalculationMode
            Tax {
              id
              Description_Tax
              MH_Code
            }
            Tariff {
              id
              Name
              Code
              Percent
            }
            Cabys {
              Percent
              Name
            }
          }
        }
      }
      BillType {
        id
        Name_BillType
      }
      BillState {
        id
        Name_BillState
      }
    }
  }
`;

export const getBill = gql`
  query getBill($id: ID!) {
    getBill(id: $id) {
      id
      Details_Bill
      OrderDate_Bill
      CashAmount
      FirebaseId_Bill
      DeliveryMoment
      DeliverDate_Bill
      Total_Bill
      SubTotal_Bill
      phoneNumber
      RequiresElectronicInvoice
      HasCreditNote
      CreditNoteInfo {
        id
        Key
        EmitedDay
        ReferenceCode
        ReferenceReason
        ConsecutiveNumber
        ActivityCode
        Receiver {
          id
          ValidBillingProfile
          UserBillingProfile {
            id
            Name
            Email
            ComercialName
            PhoneCodCountry
            PhoneNumber
            ID_Number
            MH_Province {
              id
              Name
            }
            MH_Canton {
              id
              Name
            }
            MH_District {
              id
              Name
            }
            MH_Neighborhood {
              id
              Name
            }
            OtherSigns
            MH_PersonType {
              id
              Name_PersonType
            }
          }
          Person {
            Name_Person
            Lastname_Person
            DocumentId_Person
            Email
            Phone
            Contacts {
              id
              Data_Contact
              ContactType {
                id
                Name_ContactType
              }
            }
          }
        }
        Coin {
          id
          Name_Coin
          Buy_Coin
        }
        Bill {
          id
          TypeOfPay {
            id
            Name_TypeOfPay
          }
        }
        ElectronicBillDocumentType {
          id
          Description
          Value
        }
        ElectronicBillDetail {
          id
          Quantity
          Created_At
          Updated_At
          ProductFeature {
            id
            Product {
              id
              Name_Product
              Description_Product
              Tags {
                id
                Value
              }
              InventoryDetail {
                id
              }
              Inventory {
                id
                Cellar {
                  id
                  Place {
                    id
                    Name_Place
                    Logo
                    Address {
                      id
                      Lat_Address
                      Lng_Address
                    }
                    Schedules {
                      id
                      OpenHour_Schedule
                      CloseHour_Schedule
                      Detail {
                        id
                        Day {
                          id
                          Name_Day
                          Value_Day
                        }
                      }
                    }
                  }
                }
              }
            }
            ProductPrice {
              Price_ProductPrice
              CalculationMode
              ProductionPrice
              Tax {
                id
                Description_Tax
              }
              Cabys {
                id
                Percent
                Name
                Code
              }
            }
          }
        }
        Created_At
        Updated_At
      }
      Refund {
        id
        Amount
        State
        Created_At
        Updated_At
        TypeOfPay {
          id
          Name_TypeOfPay
        }
        File {
          id
          Route_File
          Created_At
          FileType {
            id
          }
        }
      }
      TypeOfPay {
        id
        Name_TypeOfPay
      }
      File {
        id
        Route_File
        Created_At
        FileType {
          id
        }
      }
      User {
        id
        BillingProfile
        ValidBillingProfile
        FirebaseUser {
          id
          UID
        }
        NickName_User
        Person {
          id
          DocumentId_Person
          Name_Person
          Lastname_Person
          Email
          Phone
          Email
          ProfileImage
          Accounts {
            id
            UniqueId_Account
            FK_GeneralState
          }
        }

        UserBillingProfile {
          id
          Name
          Email
          ComercialName
          PhoneCodCountry
          PhoneNumber
          ID_Number
          MH_Province {
            id
            Name
          }
          MH_Canton {
            id
            Name
          }
          MH_District {
            id
            Name
          }
          MH_Neighborhood {
            id
            Name
          }
          OtherSigns
          MH_PersonType {
            id
            Name_PersonType
          }
        }
      }
      NotAvailableAddressToSend {
        id
        Lat
        Lng
        Distance
        Amount
        Tax
        Services
        Delivery
        DeliveryTax
        Time
        User {
          id
        }
        Address {
          id
        }
        Approved
      }
      Address {
        id
        Name_Address
        Description_Address
        Lat_Address
        Lng_Address
      }
      Detail {
        id
        Quantity_BillDetail
        SubTotal_BillDetail
        Total_BillDetail
        State {
          id
          Name_BillDetailState
        }
        UnitOfMeasurement {
          id
          Name_UnitOfMeasurement
          Symbol
        }
        ProductFeature {
          id
          Quantity_ProductFeature
          PreparationTime_ProductFeature
          Details {
            id
            Key_ProductKeyFeature
            Value_ProductFeatureDetail
          }
          Files {
            id
            Route_File
            Created_At
            FileType {
              id
              Name_FileType
            }
          }
          Product {
            id
            Name_Product
            Description_Product
            Tags {
              id
              Value
            }
            InventoryDetail {
              id
            }
            Inventory {
              id
              Cellar {
                id
                Place {
                  id
                  Name_Place
                  Logo
                  Address {
                    id
                    Lat_Address
                    Lng_Address
                  }
                  Schedules {
                    id
                    OpenHour_Schedule
                    CloseHour_Schedule
                    Detail {
                      id
                      Day {
                        id
                        Name_Day
                        Value_Day
                      }
                    }
                  }
                }
              }
            }
          }
          ProductPrice {
            id
            Discount {
              id
              Quantity
              StartDate
              EndDate
            }
            Price_ProductPrice
            CalculationMode
            Tax {
              id
              Description_Tax
              MH_Code
            }
            Tariff {
              id
              Name
              Code
              Percent
            }
            Cabys {
              Percent
              Name
            }
          }
        }
      }
      BillType {
        id
        Name_BillType
      }
      BillState {
        id
        Name_BillState
      }
    }
  }
`;

export const getAllCabys = gql`
  query getAllCabys {
    getAllCabys {
      id
      Name
      Percent
      Code
      Created_At
      Updated_At
    }
  }
`;

export const getCabysByCriteria = gql`
  query getCabysByCriteria($criteria: String) {
    getCabysByCriteria(criteria: $criteria) {
      id
      Code
      Name
      Percent
    }
  }
`;

export const productFeaturesNoCabys = gql`
  query productFeaturesNoCabys($FK_Place: ID!) {
    features: productFeaturesNoCabys(FK_Place: $FK_Place) {
      id
      Quantity_ProductFeature
      Location_ProductFeature
      PreparationTime_ProductFeature
      CadesurCode_ProductFeature
      LastMonthSells {
        DateSelling
        Quantity
      }
      Product {
        id
        Name_Product
        Description_Product
        Inventory {
          id
          Description
          Cellar {
            id
            Description
          }
        }
      }
      Codes {
        id
        FeatureCode
        CodeType {
          id
          Name_CodeType
        }
      }
      Files {
        id
        Route_File
        Created_At
        FileType {
          id
        }
      }
      ProductPrice {
        id
        Price_ProductPrice
        CalculationMode
        ProductionPrice
        Discount {
          id
          Quantity
          StartDate
          EndDate
        }
        Tax {
          id
          Description_Tax
          MH_Code
        }
        Tariff {
          id
          Name
          Code
          Percent
        }
        Cabys {
          id
          Code
          Name
          Percent
        }
      }
      Details {
        id
        Value_ProductFeatureDetail
        Key_ProductKeyFeature
        FK_ProductKeyFeature
      }
      Tags {
        id
        Value
      }
    }
  }
`;

export const dataByPlace = gql`
  query getCellars($FK_Place: ID!) {
    Cellars: getCellarsByPlace(id: $FK_Place) {
      id
      Description
      Color
      State_Cellar
      Created_At
      Updated_At
    }
  }
`;

export const featuresByCellar = gql`
  query featuresByCellar($FK_Cellar: ID!, $FK_Place: ID!, $offset: Int) {
    Inventories: inventoryByCellar(id: $FK_Cellar, FK_Place: $FK_Place) {
      id
      Description
      State_Inventory
      Count
    }
    featuresByCellar(FK_Cellar: $FK_Cellar, offset: $offset) {
      id
      Quantity_ProductFeature
      Location_ProductFeature
      PreparationTime_ProductFeature
      CadesurCode_ProductFeature
      LastMonthSells {
        DateSelling
        Quantity
      }
      Product {
        id
        Name_Product
        Description_Product
        Inventory {
          id
          Description
          State_Inventory
          Cellar {
            id
            Description
            State_Cellar
          }
        }
        InventoryDetail {
          id
        }
        ProductState {
          id
        }
      }
      Codes {
        id
        FeatureCode
        CodeType {
          id
          Name_CodeType
        }
      }
      Files {
        id
        Route_File
        Created_At
        FileType {
          id
        }
      }
      ProductPrice {
        id
        Price_ProductPrice
        CalculationMode
        ProductionPrice
        Discount {
          id
          Quantity
          StartDate
          EndDate
        }
        Tax {
          id
          Description_Tax
          MH_Code
        }
        Tariff {
          id
          Name
          Code
          Percent
        }
        Cabys {
          id
          Code
          Name
          Percent
        }
      }
      Details {
        id
        Value_ProductFeatureDetail
        Key_ProductKeyFeature
        FK_ProductKeyFeature
      }
      Tags {
        id
        Value
      }
    }
  }
`;

export const featuresByInventory = gql`
  query featuresByInventory(
    $FK_Inventory: ID!
    $FK_Place: ID!
    $query: ProductFeatureByInventoryInput
  ) {
    InventoriesDetails: detailByInventory(
      id: $FK_Inventory
      FK_Place: $FK_Place
    ) {
      id
      UnitOfMeasurement {
        id
        Name_UnitOfMeasurement
        Symbol
      }
      Product {
        id
        Name_Product
        Description_Product
        Restricted_Product
        Tags {
          id
          Value
        }
        MuyTicoTag {
          id
          Value
        }
        ProductState {
          id
          State
        }
      }
    }
    featuresByInventory(query: $query) {
      Features {
        id
        Quantity_ProductFeature
        Location_ProductFeature
        PreparationTime_ProductFeature
        CadesurCode_ProductFeature
        LastMonthSells {
          DateSelling
          Quantity
        }
        Product {
          id
          Name_Product
          Description_Product
          Inventory {
            id
            Description
            State_Inventory
            Cellar {
              id
              Description
              State_Cellar
            }
          }
          InventoryDetail {
            id
          }
          ProductState {
            id
          }
        }
        Codes {
          id
          FeatureCode
          CodeType {
            id
            Name_CodeType
          }
        }
        Files {
          id
          Route_File
          Created_At
          FileType {
            id
          }
        }
        ProductPrice {
          id
          Price_ProductPrice
          CalculationMode
          ProductionPrice
          Discount {
            id
            Quantity
            StartDate
            EndDate
          }
          Tax {
            id
            Description_Tax
            MH_Code
          }
          Tariff {
            id
            Name
            Code
            Percent
          }
          Cabys {
            id
            Code
            Name
            Percent
          }
        }
        Details {
          id
          Value_ProductFeatureDetail
          Key_ProductKeyFeature
          FK_ProductKeyFeature
        }
        Tags {
          id
          Value
        }
      }
    }
  }
`;

export const featuresByInventoryDetail = gql`
  query featuresByInventoryDetail($FK_Inventory_Detail: ID!, $offset: Int) {
    featuresByInventoryDetail(
      FK_Inventory_Detail: $FK_Inventory_Detail
      offset: $offset
    ) {
      id
      Quantity_ProductFeature
      Location_ProductFeature
      PreparationTime_ProductFeature
      CadesurCode_ProductFeature
      LastMonthSells {
        DateSelling
        Quantity
      }
      Product {
        id
        Name_Product
        Description_Product
        Inventory {
          id
          Description
          State_Inventory
          Cellar {
            id
            Description
            State_Cellar
          }
        }
        InventoryDetail {
          id
        }
        ProductState {
          id
        }
      }
      Codes {
        id
        FeatureCode
        CodeType {
          id
          Name_CodeType
        }
      }
      Files {
        id
        Route_File
        Created_At
        FileType {
          id
        }
      }
      ProductPrice {
        id
        Price_ProductPrice
        CalculationMode
        ProductionPrice
        Discount {
          id
          Quantity
          StartDate
          EndDate
        }
        Tax {
          id
          Description_Tax
          MH_Code
        }
        Tariff {
          id
          Name
          Code
          Percent
        }
        Cabys {
          id
          Code
          Name
          Percent
        }
      }
      Details {
        id
        Value_ProductFeatureDetail
        Key_ProductKeyFeature
        FK_ProductKeyFeature
      }
      Tags {
        id
        Value
      }
    }
  }
`;

export const queryFeatures = gql`
  query queryProductFeaturesByPlace(
    $Criteria: String!
    $Offset: Int
    $FK_Place: ID!
  ) {
    queryProductFeaturesByPlace(
      Criteria: $Criteria
      Offset: $Offset
      FK_Place: $FK_Place
    ) {
      id
      Quantity_ProductFeature
      Location_ProductFeature
      PreparationTime_ProductFeature
      CadesurCode_ProductFeature
      LastMonthSells {
        DateSelling
        Quantity
      }
      Product {
        id
        Name_Product
        Description_Product
        Inventory {
          id
          Description
          State_Inventory
          Cellar {
            id
            Description
            State_Cellar
          }
        }
        InventoryDetail {
          id
        }
        ProductState {
          id
        }
      }
      Codes {
        id
        FeatureCode
        CodeType {
          id
          Name_CodeType
        }
      }
      Files {
        id
        Route_File
        Created_At
        FileType {
          id
        }
      }
      ProductPrice {
        id
        Price_ProductPrice
        CalculationMode
        ProductionPrice
        Discount {
          id
          Quantity
          StartDate
          EndDate
        }
        Tax {
          id
          Description_Tax
          MH_Code
        }
        Tariff {
          id
          Name
          Code
          Percent
        }
        Cabys {
          id
          Code
          Name
          Percent
        }
      }
      Details {
        id
        Value_ProductFeatureDetail
        Key_ProductKeyFeature
        FK_ProductKeyFeature
      }
      Tags {
        id
        Value
      }
    }
  }
`;

export const getRandomByPlace = gql`
  query getRandomByPlace($Limit: Int, $Offset: Int, $FK_Place: ID!) {
    getRandomByPlace(Limit: $Limit, Offset: $Offset, FK_Place: $FK_Place) {
      id
      Quantity_ProductFeature
      Location_ProductFeature
      PreparationTime_ProductFeature
      CadesurCode_ProductFeature
      LastMonthSells {
        DateSelling
        Quantity
      }
      Product {
        id
        Name_Product
        Description_Product
        Inventory {
          id
          Description
          State_Inventory
          Cellar {
            id
            Description
            State_Cellar
          }
        }
        InventoryDetail {
          id
        }
        ProductState {
          id
        }
      }
      Codes {
        id
        FeatureCode
        CodeType {
          id
          Name_CodeType
        }
      }
      Files {
        id
        Route_File
        Created_At
        FileType {
          id
        }
      }
      ProductPrice {
        id
        Price_ProductPrice
        CalculationMode
        ProductionPrice
        Discount {
          id
          Quantity
          StartDate
          EndDate
        }
        Tax {
          id
          Description_Tax
          MH_Code
        }
        Tariff {
          id
          Name
          Code
          Percent
        }
        Cabys {
          id
          Code
          Name
          Percent
        }
      }
      Details {
        id
        Value_ProductFeatureDetail
        Key_ProductKeyFeature
        FK_ProductKeyFeature
      }
      Tags {
        id
        Value
      }
    }
  }
`;

export const tagsByInventory = gql`
  query tagsByInventory($id: ID!) {
    tagsByInventory(id: $id) {
      id
      Value
    }
  }
`;

export const featureById = gql`
  query featureById($id: ID!) {
    featureById(id: $id) {
      id
      Quantity_ProductFeature
      Location_ProductFeature
      PreparationTime_ProductFeature
      CadesurCode_ProductFeature
      LastMonthSells {
        DateSelling
        Quantity
      }
      Product {
        id
        Name_Product
        Description_Product
        Inventory {
          id
          Description
          State_Inventory
          Cellar {
            id
            Description
            State_Cellar
          }
        }
        InventoryDetail {
          id
        }
        ProductState {
          id
        }
      }
      Codes {
        id
        FeatureCode
        CodeType {
          id
          Name_CodeType
        }
      }
      Files {
        id
        Route_File
        Created_At
        FileType {
          id
        }
      }
      ProductPrice {
        id
        Price_ProductPrice
        CalculationMode
        ProductionPrice
        Discount {
          id
          Quantity
          StartDate
          EndDate
        }
        Tax {
          id
          Description_Tax
          MH_Code
        }
        Tariff {
          id
          Name
          Code
          Percent
        }
        Cabys {
          id
          Code
          Name
          Percent
        }
      }
      Details {
        id
        Value_ProductFeatureDetail
        Key_ProductKeyFeature
        FK_ProductKeyFeature
      }
      Tags {
        id
        Value
      }
    }
  }
`;

export const topFeatures = gql`
  query topFeatures($date: DateTime!, $limit: Int!, $states: [Int]) {
    topFeatures(date: $date, limit: $limit, states: $states) {
      id
      Count
      Quantity_ProductFeature
      Location_ProductFeature
      PreparationTime_ProductFeature
      CadesurCode_ProductFeature
      LastMonthSells {
        DateSelling
        Quantity
      }
      Product {
        id
        Name_Product
        Description_Product
        Inventory {
          id
          Description
          State_Inventory
          Cellar {
            id
            Description
            State_Cellar
          }
        }
        InventoryDetail {
          id
        }
        ProductState {
          id
        }
      }
      Codes {
        id
        FeatureCode
        CodeType {
          id
          Name_CodeType
        }
      }
      Files {
        id
        Route_File
        Created_At
        FileType {
          id
        }
      }
      ProductPrice {
        id
        Price_ProductPrice
        CalculationMode
        ProductionPrice
        Discount {
          id
          Quantity
          StartDate
          EndDate
        }
        Tax {
          id
          Description_Tax
          MH_Code
        }
        Tariff {
          id
          Name
          Code
          Percent
        }
        Cabys {
          id
          Code
          Name
          Percent
        }
      }
      Details {
        id
        Value_ProductFeatureDetail
        Key_ProductKeyFeature
        FK_ProductKeyFeature
      }
      Tags {
        id
        Value
      }
    }
  }
`;

export const queryRecentUsers = gql`
  query queryRecentUsers($criteria: String, $offset: Int) {
    users: queryRecentUsers(offset: $offset, criteria: $criteria) {
      id
      Email
      Given_Name
      Family_Name
      Picture
      Locale
      Phone_Number
      UID
      Provider_Id
      Created_At
      Updated_At
      User {
        id
        Person {
          id
          Name_Person
          Lastname_Person
          Phone
          Email
          BirthDate_Person
          ProfileImage
        }
        Cart {
          id
        }
      }
    }
  }
`;

export const devicesByUser = gql`
  query devicesByUser($FK_User: ID) {
    devicesByUser(FK_User: $FK_User) {
      id
      uuid
      Token_NotificationDevice
      FK_Place
      Created_At
      Updated_At
    }
  }
`;

export const PlaceById = gql`
  query PlaceById($id: ID!) {
    place: PlaceById(id: $id) {
      id
      Name_Place
      Description_Place
      Code
      Lat
      Lng
      Sinpe_Number
      Activity {
        id
        id_MH
        Name
      }
      Company {
        User {
          id
          UserBillingProfile {
            id
            Name
            Email
            ComercialName
            PhoneCodCountry
            PhoneNumber
          }
        }
      }
      Delivery {
        id
        Radius
        Available
        Price
        Updated_At
        FreeShipping
        Latitude
        Longitude
        Address
        ProfitPercentage
      }
      Role {
        id
        Name_Role
        Value_Role
      }
      Logo
      PlaceTags {
        id
        Value
        Color
      }
    }
  }
`;

export const ninja = gql`
  query ninja($uid: ID!) {
    ninja(uid: $uid)
  }
`;

export const featuresNotInReport = gql`
  query featuresNotInReport($features: [ID]!, $FK_Place: ID!) {
    featuresNotInReport(features: $features, FK_Place: $FK_Place) {
      id
      Quantity_ProductFeature
      CadesurCode_ProductFeature
      Product {
        id
        Name_Product
        Description_Product
      }
      Files {
        Route_File
      }
      Details {
        Value_ProductFeatureDetail
        Key_ProductKeyFeature
      }
    }
  }
`;

export const locationsByPlace = gql`
  query locationsByPlace($FK_Place: ID!) {
    locationsByPlace(FK_Place: $FK_Place)
  }
`;

export const toDeliverByDate = gql`
  query toDeliverByDate($dateA: DateTime!, $dateB: DateTime!, $FK_Place: ID!) {
    toDeliverByDate(dateA: $dateA, dateB: $dateB, FK_Place: $FK_Place) {
      id
      DeliveryMoment
      User {
        id
        BillingProfile
        ValidBillingProfile
        FirebaseUser {
          id
          UID
        }
        Person {
          id
          DocumentId_Person
          Name_Person
          Lastname_Person
          Email
          Phone
          Email
          ProfileImage
        }
      }
      AdminCreator
    }
  }
`;
export const getDetailsByInventory = gql`
  query GetDetailsByInventory($billId: Int!, $stateId: Int!) {
    getDetailsByInventory(Bill_Id: $billId, stateId: $stateId) {
      id
      name
      products {
        quantity
        id
        total
        subtotal
        feature {
          Location_ProductFeature
          Files {
            Route_File
            Name_File
          }
          ProductPrice {
            Price_ProductPrice
            CalculationMode
            ProductionPrice
          }
          Product {
            Name_Product
            Inventory {
              id
              Cellar {
                id
              }
            }
            InventoryDetail {
              id
              UnitOfMeasurement {
                id
                Name_UnitOfMeasurement
                Symbol
              }
            }
          }
        }
      }
    }
  }
`;
export const getBillsToPrepare = gql`
  query Query($fkPlace: ID) {
    billsToPrepare(FK_Place: $fkPlace) {
      id
    }
  }
`;
export const findBillsByState = gql`
  query findBillsByState(
    $FK_Place: Int!
    $State_Id: Int!
    $page: Int
    $size: Int
  ) {
    findBillsByState(
      FK_Place: $FK_Place
      State_Id: $State_Id
      page: $page
      size: $size
    ) {
      id
      Details_Bill
      OrderDate_Bill
      CashAmount
      FirebaseId_Bill
      DeliveryMoment
      DeliverDate_Bill
      Total_Bill
      SubTotal_Bill
      phoneNumber
      HasCreditNote
      Created_At
      CreditNoteInfo {
        id
        Key
        EmitedDay
        ReferenceCode
        ReferenceReason
        ConsecutiveNumber
        ActivityCode
        Receiver {
          id
          ValidBillingProfile
          UserBillingProfile {
            id
            Name
            Email
            ComercialName
            PhoneCodCountry
            PhoneNumber
            ID_Number
            MH_Province {
              id
              Name
            }
            MH_Canton {
              id
              Name
            }
            MH_District {
              id
              Name
            }
            MH_Neighborhood {
              id
              Name
            }
            OtherSigns
            MH_PersonType {
              id
              Name_PersonType
            }
          }
          Person {
            Name_Person
            Lastname_Person
            DocumentId_Person
            Email
            Phone
            Contacts {
              id
              Data_Contact
              ContactType {
                id
                Name_ContactType
              }
            }
          }
        }
        Coin {
          id
          Name_Coin
          Buy_Coin
        }
        Bill {
          id
          TypeOfPay {
            id
            Name_TypeOfPay
          }
        }
        ElectronicBillDocumentType {
          id
          Description
          Value
        }
        ElectronicBillDetail {
          id
          Quantity
          Created_At
          Updated_At
          ProductFeature {
            id
            Product {
              id
              Name_Product
              Description_Product
              Tags {
                id
                Value
              }
              InventoryDetail {
                id
              }
              Inventory {
                id
                Cellar {
                  id
                  Place {
                    id
                    Name_Place
                    Logo
                    Address {
                      id
                      Lat_Address
                      Lng_Address
                    }
                    Schedules {
                      id
                      OpenHour_Schedule
                      CloseHour_Schedule
                      Detail {
                        id
                        Day {
                          id
                          Name_Day
                          Value_Day
                        }
                      }
                    }
                  }
                }
              }
            }
            ProductPrice {
              Price_ProductPrice
              CalculationMode
              ProductionPrice
              Tax {
                id
                Description_Tax
              }
              Cabys {
                id
                Percent
                Name
                Code
              }
            }
          }
        }
        Created_At
        Updated_At
      }
      RequiresElectronicInvoice
      Refund {
        id
        Amount
        State
        Created_At
        Updated_At
        TypeOfPay {
          id
          Name_TypeOfPay
        }
        File {
          id
          Route_File
          Created_At
          FileType {
            id
          }
        }
      }
      Detail {
        id
        State {
          id
          Name_BillDetailState
        }
        ProductFeature {
          id
          Product {
            id
            Name_Product
            Description_Product
          }
          ProductPrice {
            Price_ProductPrice
            CalculationMode
            ProductionPrice
            Tax {
              id
              Description_Tax
            }
            Cabys {
              id
              Percent
              Name
              Code
            }
          }
        }
        Quantity_BillDetail
      }
      Coin {
        id
        Name_Coin
        Symbol_Coin
        Buy_Coin
        Sell_Coin
      }
      File {
        id
        Route_File
        FileType {
          id
          Name_FileType
        }
      }
      Address {
        id
        Description_Address
        Name_Address
        Lat_Address
        Lng_Address
      }
      BillState {
        id
        Name_BillState
      }
      TypeOfPay {
        id
        Name_TypeOfPay
      }
      User {
        id
        BillingProfile
        ValidBillingProfile
        UserBillingProfile {
          id
          Name
          MH_PersonType {
            id
            Name_PersonType
            Code
          }
          ID_Number
          IDForeign
          ComercialName
          Email
          PhoneCodCountry
          PhoneNumber
          Tax_Registration
          MH_Province {
            id
            Name
            id_MH
          }
          MH_Canton {
            id
            Name
            id_MH
          }
          MH_District {
            id
            Name
            id_MH
          }
          MH_Neighborhood {
            id
            Name
            id_MH
          }
          MH_User {
            idUser
            fullName
            userName
            email
            pwd
            about
            country
            FileEB {
              idFile
              md5
              name
              timestamp
              size
              idUser
              fileType
              type
            }
            Session {
              idSession
              idUser
              sessionKey
              ip
              lastAccess
            }
            MH_User
            MH_Password
          }
          OtherSigns
          OtherSignsForeign
        }
        Person {
          id
          Name_Person
          Lastname_Person
          DocumentId_Person
          ProfileImage
          Email
          Phone
          Contacts {
            id
            Data_Contact
            ContactType {
              id
              Name_ContactType
              FontAwesomeIcon_ContactType
            }
          }
          Files {
            id
            Route_File
            Created_At
            FileType {
              id
            }
          }
        }
      }
    }
  }
`;
export const getAdminsByPlace = gql`
  query getAdminsByPlace($placeId: Int!) {
    users: getAdminsByPlace(placeId: $placeId) {
      id
      Email
      Given_Name
      Family_Name
      Picture
      Locale
      Phone_Number
      UID
      Provider_Id
      Created_At
      Updated_At
      User {
        id
        Person {
          id
          Name_Person
          Lastname_Person
          Phone
          Email
          BirthDate_Person
          ProfileImage
          DocumentId_Person
        }
        UserRoles {
          id
        }
        Roles {
          Name_Role
          id
        }
      }
    }
  }
`;

export const getPermissionsByUser = gql`
  query getPermissionsByUser($placeId: Int!, $userId: Int!) {
    permissions: getPermissionsByUser(placeId: $placeId, userId: $userId) {
      access
      submoduleId
      submoduleName
      permissionId
    }
  }
`;

export const allPersonType = gql`
  query getAllPersonType {
    personTypes: getAllPersonType {
      id
      Name_PersonType
      Code
    }
  }
`;

export const getPermissionsSubmodules = gql`
  query getPermissionsSubmodules($roleId: Int!) {
    submodules: getPermissionsSubmodules(roleId: $roleId) {
      id
      Name_Submodule
      Route_Submodule
    }
  }
`;
export const getPlace = gql`
  query getPlace($where: GetPlaceWhereInput!) {
    place: getPlace(where: $where) {
      id
      BillingProfile {
        id
        Name
        MH_PersonType {
          id
          Name_PersonType
          Code
        }
        ID_Number
        IDForeign
        ComercialName
        Email
        PhoneCodCountry
        PhoneNumber
        Tax_Registration
        MH_Province {
          id
          Name
          id_MH
        }
        MH_Canton {
          id
          Name
          id_MH
        }
        MH_District {
          id
          Name
          id_MH
        }
        MH_Neighborhood {
          id
          Name
          id_MH
        }
        MH_User {
          idUser
          fullName
          userName
          email
          pwd
          about
          country
          FileEB {
            idFile
            md5
            name
            timestamp
            size
            idUser
            fileType
            type
          }
          Session {
            idSession
            idUser
            sessionKey
            ip
            lastAccess
          }
          MH_User
          MH_Password
        }
        OtherSigns
        OtherSignsForeign
      }
      DefaultBillingProfile {
        id
        Name
        MH_PersonType {
          id
          Name_PersonType
          Code
        }
        ID_Number
        IDForeign
        ComercialName
        Email
        PhoneCodCountry
        PhoneNumber
        Tax_Registration
        MH_Province {
          id
          Name
          id_MH
        }
        MH_Canton {
          id
          Name
          id_MH
        }
        MH_District {
          id
          Name
          id_MH
        }
        MH_Neighborhood {
          id
          Name
          id_MH
        }
        MH_User {
          idUser
          fullName
          userName
          email
          pwd
          about
          country
          FileEB {
            idFile
            md5
            name
            timestamp
            size
            idUser
            fileType
            type
          }
          Session {
            idSession
            idUser
            sessionKey
            ip
            lastAccess
          }
          MH_User
          MH_Password
        }
        OtherSigns
        OtherSignsForeign
      }
    }
  }
`;

export const getByBillIdTypeFE = gql`
  query getByBillIdTypeFE($FK_Bill: ID, $type: Int) {
    electronicBill: getByBillIdTypeFE(FK_Bill: $FK_Bill, type: $type) {
      id
      Bill {
        id
      }
      FK_ElectronicBillDocumentType
      FK_Bill
      ActivityCode
    }
  }
`;

export const getAllReferenceCode = gql`
  query getAllReferenceCode {
    allReferenceCode: getAllReferenceCode {
      id
      Document_Type
    }
  }
`;

export const getAllActivities = gql`
  query getAllActivities {
    allActivities: getAllActivities {
      id
      id_MH
      Name
    }
  }
`;

export const getTopSellingProducts = gql`
  query getTopSellingProducts(
    $StartDate_Bill: String
    $EndDate_Bill: String
    $FK_BillDetailState: Int
  ) {
    getTopSellingProducts: getTopSellingProducts(
      StartDate_Bill: $StartDate_Bill
      EndDate_Bill: $EndDate_Bill
      FK_BillDetailState: $FK_BillDetailState
    ) {
      productId
      productName
      totalQuantitySold
      inventoryId
      inventoryDetailId
      cellarColor
    }
  }
`;

export const getTopBuyingUsers = gql`
  query getTopBuyingUsers(
    $FK_Place: ID!
    $StartDate_Bill: String!
    $EndDate_Bill: String!
  ) {
    getTopBuyingUsers(
      FK_Place: $FK_Place
      StartDate_Bill: $StartDate_Bill
      EndDate_Bill: $EndDate_Bill
    ) {
      User {
        id

        Person {
          id
          Name_Person
          Lastname_Person
          DocumentId_Person
          ProfileImage
          Email
          Phone
        }
      }
      purchases
    }
  }
`;

export const validateProductFeature = gql`
  query validateProductFeature($id: String!, $quantity: Int!) {
    validateProductFeatureAvailableSingle(id: $id, quantity: $quantity)
  }
`;
